export default function (element) {
	return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}



// WEBPACK FOOTER //
// ./js/utilities/is-visible/u-is-visible.js